import styled from 'styled-components';

export const ExcavationPermitIframe = styled.iframe`
    min-width: 100%;
    max-width: 100%;
    border: none;
    height: 33.6875rem; // initial height, after loading the Jotform overrides itself
`;
